module.exports = _.set;